import { useEffect, useState } from 'react';
import r from 'render-dom';
import styled from 'styled-components';

import Modal from 'components/ui/Modal';
import { getJwt } from 'utils/jwt';
import { isProduction } from 'constants/settings';

const StyledModal = styled(Modal)`
    text-align: center;

    h2 {
        color: #333;
    }

    img {
        max-height: 75px;
    }

    p {
        color: #333;
        line-height: 1.5;
        margin-left: auto;
        margin-right: auto;
        max-width: 600px;
    }
`;

export default function RedirectModal() {
    const [countdown, setCountdown] = useState(30);
    const jwt = getJwt();
    const appEnvironment = isProduction ? '' : '-staging';
    const redirectLink = `https://app${appEnvironment}.snagshout.com${window.location.pathname}?token=${jwt}`;

    function countdownOneSecond(seconds) {
        setTimeout(() => {
            setCountdown(seconds - 1);
        }, 1000);
    }

    useEffect(() => {
        if (countdown > 0) {
            countdownOneSecond(countdown);
        } else {
            window.location.replace(redirectLink);
        }
    }, [countdown]);

    return (
        r(StyledModal, {
            className: 'rounded-dialog',
            open: true,
            showCloseButton: false,
            style: { maxWidth: 800 }
        }, [
            r.img({ src: `${process.env.PUBLIC_URL}/images/snagshout-partners-black.webp` }),
            r.h2(['Massview is now Snagshout Partners']),
            r.p([
                `It's all the same, only the name has changed. Use your Massview email and password
                to log in at `,
                r.a({ href: redirectLink }, [`app${appEnvironment}.snagshout.com.`]),
                ' See you there!',
            ]),
            r.p([
                `Redirecting to Snagshout Partners in... ${countdown} second${countdown !== 1 ? 's' : ''}`
            ]),
        ])
    );
}
